import styled from "styled-components"

import { ChatView } from "../constants"

type ChatMessageWrapperProps = {
  $isMe: boolean
}

export const ChatMessageWrapper = styled.div<ChatMessageWrapperProps>`
  width: inherit;
  line-height: 1.2;
  border-radius: 15px;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  font-size: 0.92rem;

  .message-data {
    display: flex;
    align-items: center;

    grid-gap: 8px;
  }

  .message-text {
    word-break: break-word;
    margin: 0;
    margin-top: 2px;
    display: inline-block;
  }

  &[data-pull-right="true"] {
    align-self: flex-end;

    .message-data {
      flex-direction: row-reverse;
    }

    .message-text {
      align-self: "flex-end";
    }
  }

  &[data-view="${ChatView.OVERLAY}"] {
    background: transparent;
    color: white;
  }
`

export const ChatNotificationContainer = styled.li`
  &[data-view=${ChatView.OVERLAY}] {
    text-align: left;
  }
`
